import { Utils } from '../../common';
import { DateFNS } from '../../common/3rd';
import { PredefinedCheckRuleOptions } from '../../types';

export const AgeRange = (options: PredefinedCheckRuleOptions): boolean => {
	let { value, params } = options;
	if (Utils.isEmpty(value) || Utils.isEmpty(params)) {
		// 值为空, 不需要比较, 通过校验
		return true;
	}

	let min = 0,
		max = 999999,
		includeMax = true,
		includeMin = true,
		minInDay = false,
		maxInDay = false;
	// eslint-disable-next-line
	const defs = params.match(/^(\[|\()?(\d{1,3})?([d|D\y|Y]?),(\d{1,3})?([d|D\y|Y]?)(\]|\)?)$/);
	if (defs == null) {
		throw new Error(`Parameters[${params}] is incorrect.`);
	}
	includeMin = defs[1] !== '(';
	if (defs[2]) {
		min = defs[2];
	}
	minInDay = defs[3] === 'd' || defs[3] === 'D';
	if (defs[4]) {
		max = defs[4];
	}
	maxInDay = defs[5] === 'y' || defs[5] === 'Y';
	includeMax = defs[6] !== ')';

	let ageInYear = value;
	let ageInDays = 0;
	if (value.indexOf('/') !== -1) {
		// 是日期
		ageInYear = DateFNS.diffInYears(new Date(), value);
		ageInDays = DateFNS.diffInDays(new Date(), value);
	}

	if (minInDay) {
		// 最小值按天计算
		if (includeMin) {
			// 包括最小值
			if (ageInDays < min) {
				return false;
			}
		} else if (ageInDays <= min) {
			// 不包括最小值
			return false;
		}
	} else {
		// 最小值按年计算
		if (includeMin) {
			// 包括最小值
			if (ageInYear < min) {
				return false;
			}
		} else if (ageInYear <= min) {
			// 不包括最小值
			return false;
		}
	}

	if (maxInDay) {
		// 最大值按天计算
		if (includeMax) {
			// 包括最大值
			if (ageInDays > max) {
				return false;
			}
		} else if (ageInDays >= max) {
			// 不包括最大值
			return false;
		}
	} else {
		// 最大值按年计算
		if (includeMax) {
			// 包括最大值
			if (ageInYear > max) {
				return false;
			}
		} else if (ageInYear >= max) {
			// 不包括最大值
			return false;
		}
	}

	return true;
};
